import store from "@/store";
import HttpService from "./httpService";
import { ForgeInspection } from './../scripts/js/forgeModels';
import config from '../../appConfig';

// const amisBaseUrl = "https://pertamina-api.a-mis.com/api/Mods/";

export function CALL_AMIS_API(endPoint, data, useAuth = true) {
    return new Promise((resolve, reject) => {
        const authToken = store.getters["GET_AMIS_TOKEN"]

        if (useAuth && !authToken) {
            store.dispatch("alert_Forge", { message: `Please wait we are connecting with A-MIS.` });
            reject("Unauthorized");
        }

        HttpService.post({
            baseURL : config.AMIS_API_URL,
            url: endPoint,
            headers: {
                "Authorization": `Bearer ${authToken}`,
                "Content-Type": "application/json"
            },
            data: {
                token: authToken,
                ...data
            }
        }).then(response => {
            if (response.data && response.data.code == 0) {
                resolve(response.data.data);
            }
            else {
                reject(response.msg);
            }
        }).catch(error => {
            console.log(error)
            reject(error);
        })
    });
}

// This API onSuccess returns code 0 in response with the token.
// onError returns negative code with null data
export function getAMISToken() {
    return new Promise((resolve, reject) => {
        HttpService.get('api/AMIS/getToken').then(response => {
            resolve(response.data.data);
        }).catch(error => {
            console.log(error)
            reject(error);
        });
    })
}

export function getAmisPlantList() {
    return CALL_AMIS_API("GetAmisPlantLst");
}

export function getLifeColorOption(filterObject = {}) {
    return CALL_AMIS_API("GetLifeColorOption", filterObject);
}

export function getAmisReadData(pltCode) {
    return CALL_AMIS_API("GetAmisReadData", { "pltCode": pltCode });
}

export function getUpdatedAMISInspections(assetId, units) {
    return new Promise((resolve, reject) => { 
        HttpService.post({
            url: `api/AMIS/getUpdatedTags`,
            data: { assetId, units },
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            console.log(error)
            reject(error);
        })
    });
}

export function updateAMISTags(assetId, data) {
    return new Promise((resolve, reject) => { 
        HttpService.post({
            url: `api/AMIS/updateAMIS`,
            params: { assetId },
            data: { ...data },
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            console.log(error)
            reject(error);
        })
    });
}

export function getAMISTags(from, to, searchText = '', reload = true) {
    return new Promise((resolve, reject) => { 
        HttpService.get({
            url: `api/AMIS/fetchAdminAMISInspections`,
            params: {
                assetId: store.state.assetId,
                index: from,
                range: to,
                searchText: searchText ? btoa(searchText) : ''
            },            
        }).then(response => {  
            let tags = response.data.inspections.map(o => Object.assign(new ForgeInspection(), o));
            tags.forEach(o => o.parseContent());

            if (reload) store.commit("SET_AMIS_TAGS", []);

            store.commit("SET_AMIS_TAGS", store.getters['GET_AMIS_TAGS'].concat(tags));
            store.commit("SET_AMIS_TAGS_TOTAL_COUNT", response.data.totalSearchResult);
            resolve(response.data);
        }).catch(error => {
            console.log(error)
            reject(error);
        })
    });
}

export function getAMISTagById(id) {
    return new Promise((resolve, reject) => {
        try {
            HttpService.get({
                url: `api/AMIS/getAMISTagById`,
                params: { id },
            }).then(response => {
                if (response.data) {
                    let amisTag = Object.assign(new ForgeInspection(), response.data)
                    amisTag.parseContent()
                    resolve(amisTag);
                } else {
                    reject(null);
                }
            }).catch(error => {
                console.log(error)
                reject(error);
            })

            // forgeFetch(`api/AMIS/getAMISTagById?id=${id}`, amisTag => {
            //     if (amisTag) {
            //         amisTag = Object.assign(new ForgeInspection(), amisTag)
            //         amisTag.parseContent()
            //         resolve(amisTag);
            //     }
            // })
        } catch (error) {
            console.log(error);
            reject(error);
        }
    })
}

export function getInspectionTagsByIds(ids) {
    return new Promise((resolve, reject) => {
        HttpService.post({
            url: `api/inspections/getByIds`,
            data: ids,
        }).then(response => {
            let tags = [];
            response.data.forEach(t => {
                let tag = Object.assign(new ForgeInspection(), t)
                tag.parseContent()
                tags.push(tag);
            })                
            resolve(tags);
        }).catch(error => {
            console.log(error)
            reject(error);
        })
    })
}

export function getAMISInspectionTagsByIds(ids) {
    return new Promise((resolve, reject) => {
        HttpService.post({
            url: `api/AMIS/getInspectionsByIds`,
            data: ids,
        }).then(response => {
            let tags = [];
            response.data.forEach(t => {
                let amisTag = Object.assign(new ForgeInspection(), t)
                amisTag.parseContent()
                tags.push(amisTag);
            })                
            resolve(tags);
        }).catch(error => {
            console.log(error)
            reject(error);
        })

        // postData(`api/AMIS/getInspectionsByIds`, ids,
        //     result => {
        //         let tags = [];
        //         result.forEach(t => {
        //             let amisTag = Object.assign(new ForgeInspection(), t)
        //             amisTag.parseContent()
        //             tags.push(amisTag);
        //         })                
        //         resolve(tags);
        //     },
        //     error => {
        //         console.log(error);
        //         reject(error);
        //     })
    })
}

export function getInspectionTagTree() {
    return new Promise((resolve, reject) => {
        let units = store.getters['GET_AMIS_UNITS']?.filter(o => o.isChecked)?.map(o => o.name);
        let searchText = store.getters["GET_AMIS_SEARCH_TEXT"];
        let assetId = store.state.assetId;
        let data = {
            assetId,
            SearchText64: searchText ? btoa(searchText) : '',
            SelectedUnits: units
        }

        HttpService.post({
            url: `api/AMIS/getInspectionTagTree`,
            data: data,
        }).then(response => {
            let result = response.data;

            let data = {
                id: 'root',
                name: 'Inspection Tree',
                children: []
            }
            if (result.fluidTree?.length > 0) {
                data.children.push({
                    id: 'fc',
                    name: 'Fluid Classification',
                    children: result.fluidTree
                });                
            }
            if (result.clTree?.length > 0) {
                data.children.push({
                    id: 'cl',
                    name: 'Corrosion Loop',
                    children: result.clTree
                });
            }
            store.commit('SET_INSPECTION_TAG_TREE', data);
            store.state.forgeService.update3dIconsInAllViews();
            resolve(data);
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    })
}
export function getNodeChildrenDbIds(inspectionsIds) {
    return new Promise((resolve, reject) => {
        HttpService.post({
            url: `api/AMIS/getInspectionsChildrenDbIds`,
            data: inspectionsIds,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            console.log(error)
            reject(error);
        });
    })
}
